import angular from 'angular';
import moment from 'moment';
import { BancodeHorasService } from '../bancodehoras.service';
import { ApuracoesPontoService } from '../../ApuracoesPonto/apuracoesponto.service';
import { TrabalhadoresService } from '../../../../Trabalhadores/trabalhadores.service';
import { IBancoHoras } from '../../models/bancohoras.model';
import { IBancoHorasColaboradores } from '../../models/bancohorascolaboradores.model';
import { IApuracaoPonto, IApuracaoSelectItem } from '../../models/apuracaoponto.model';

type BancoHorasFilters = {
    apuracaoinicial: IApuracaoSelectItem | null;
    apuracaofinal: IApuracaoSelectItem | null;
    lotacao: { lotacao: string } | null;
    departamento: { departamento: string } | null;
    grupo: { grupo: string } | null;
    trabalhador: { trabalhador: string } | null;
    situacaoColaborador: string | null;
};

export class BancodeHorasIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        'BancodeHorasService',
        'ApuracoesPontoService',
        'TrabalhadoresService',
    ];

    public busy: boolean = false;
    public busyFilter: boolean = false;
    public entitiesLoaded: boolean = false;
    public filterTouched: boolean = false;
    public entities: Array<IBancoHorasColaboradores> = [];
    public apuracoesSelect: IApuracaoSelectItem[] = [];
    public filters: BancoHorasFilters = {
        apuracaoinicial: null,
        apuracaofinal: null,
        lotacao: null,
        departamento: null,
		grupo: null,
		trabalhador: null,
        situacaoColaborador: '00',
    };
    public filtersParams = {
        empresa: '',
        estabelecimento: ''
    };
    public apuracoes: Array<IApuracaoPonto> = [];
    public pontoPorLotacao: boolean = false;

    constructor (
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissao: (arg: string) => boolean,
            modoGestorPermissao: (arg: string) => boolean,
            session: any,
            configuracoes: any,
            nsjGlobals: any
        },
		public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
		public BancodeHorasService: BancodeHorasService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public TrabalhadoresService: TrabalhadoresService,
	) {
        if (
            !this.$rootScope.temPermissao('visualizar_banco_horas') ||
			!this.$rootScope.liberadoTela('LIBERAR_BANCO_HORAS')
        ) {
            $state.go('dp');
        }

        this.busy = true;
        this.pontoPorLotacao = this.$rootScope.configuracoes.PONTO_APURAR_POR_LOTACAO;
        this.carregaApuracoes();

        this.$scope.$on('historicosbancoapuracoes_index_loaded', (event, args: any) => {
            this.entities = this.formataPeriodo(args);
            this.busy = false;
            this.busyFilter = false;
            this.entitiesLoaded = true;

            // verifica se é ponto por lotação e agrupa o colaborador por lotação
            if (this.pontoPorLotacao) {
                this.entities = this.agruparLotacoes();
            }
        });
        this.$scope.$on('apuracoesponto_index_loaded', () => {
            if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.montaApuracaoSelect();
                this.busy = false;
            }
        });
        this.$scope.$on('historicosbancoapuracoes_relatoriobancoshoras_sucesso', (event, args: any) => {
			this.download(args.data);
            this.busy = false;
        });
        this.$scope.$on('historicosbancoapuracoes_relatoriobancoshoras_erro', () => {
            this.busy = false;
        });
        this.$scope.$on('historicosbancoapuracoes_pdf_sucesso', (event, args: any) => {
			this.download(args.data, true);
            this.busy = false;
        });
        this.$scope.$on('historicosbancoapuracoes_pdf_erro', () => {
            this.busy = false;
        });
    }

	carregaApuracoes() {
        this.busy = true;
		this.ApuracoesPontoService.constructors['vigente'] = false;
		this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
		this.ApuracoesPontoService.constructors['estabelecimento'] = '';
		this.apuracoes = this.ApuracoesPontoService.reload();
	}

    montaApuracaoSelect(): void {
        this.apuracoesSelect = this.apuracoes.map((element) => {
            const { nome: nomeReferencia, referencia } = this.getReferenciaApuracao(element);
            return {
                periodo: `
                    ${moment(element.inicioapuracao).format('DD/MM/YYYY')} a
                    ${moment(element.terminoapuracao).format('DD/MM/YYYY')} ${nomeReferencia}`,
                inicioapuracao: element.inicioapuracao,
                terminoapuracao: element.terminoapuracao,
                apuracaoponto: element.apuracaoponto,
                referencia
            };
        });
        this.setFilterApuracao();
        this.filterApuracao();
	}

    getReferenciaApuracao(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                nome: `- Trabalhador: ${apuracao.trabalhadorobj.nome}`,
                referencia: apuracao.trabalhadorobj
            };
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return {
                nome: `- Lotação: ${apuracao.lotacaoobj.nome} `,
                referencia: apuracao.lotacaoobj
            };
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                nome: `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`,
                referencia: apuracao.estabelecimentoobj
            };
        }
        if (apuracao.empresaobj?.empresa) {
            return {
                nome: `- Empresa: ${apuracao.empresaobj.razaosocial}`,
                referencia: apuracao.empresaobj
            };
        }
        return {
            nome: '',
            referencia: null
        };
    }

    setFilterApuracao() {
        if (!this.apuracoesSelect.length) {
            return;
        }

        const dataAtual = moment().format('YYYY-MM');
        const dataAtualMenosUmMes = moment().subtract(1, 'month').format('YYYY-MM');
        const dataAtualMenosDoisMeses = moment().subtract(2, 'months').format('YYYY-MM');

        const encontrarApuracaoPorMes = (mes: string) =>
            this.apuracoesSelect.find(apuracao =>
                [apuracao.inicioapuracao, apuracao.terminoapuracao].some(data => (
                    moment(data).format('YYYY-MM') === mes &&
                    apuracao.referencia &&
                    ('empresa' in apuracao.referencia)
                ))
            );

        const apuracaoInicial = [dataAtualMenosDoisMeses, dataAtualMenosUmMes, dataAtual]
            .map(mes => encontrarApuracaoPorMes(mes))
            .find(apuracao => apuracao !== undefined);
        this.filters.apuracaoinicial = apuracaoInicial ?? this.apuracoesSelect[0];

        const apuracaoFinal = encontrarApuracaoPorMes(dataAtual);
        this.filters.apuracaofinal = apuracaoFinal ?? this.apuracoesSelect[0];
    }

    filterApuracao() {
        const apuracao = this.filters.apuracaoinicial;
        if (!apuracao) {
            return;
        }

        const filtersToReset = ['grupo', 'lotacao', 'departamento', 'trabalhador'];
        filtersToReset.forEach(key => this.filters[key] = null);

        let empresa = this.$rootScope.session.entities.empresa.empresa;
        let estabelecimento = '';

        const referencia = apuracao.referencia;
        if (!referencia) {
            this.refreshFilters(empresa, estabelecimento);
            return;
        }

        if ('empresa' in referencia) {
            empresa = referencia.empresa;
        } else if ('estabelecimento' in referencia) {
            estabelecimento = referencia.estabelecimento;
        }

        this.refreshFilters(empresa, estabelecimento);

        if ('lotacao' in referencia) {
            this.filters.lotacao = referencia;
        } else if ('trabalhador' in referencia) {
            this.filters.trabalhador = referencia;
        }
    }

    refreshFilters(empresa: string = '', estabelecimento: string = '') {
        this.filtersParams = { empresa, estabelecimento };

        const events = ['trabalhador_refresh', 'lotacao_refresh', 'departamento_refresh'];

        events.forEach(event =>
            this.$rootScope.$broadcast(event, this.filtersParams)
        );
    }

    formataPeriodo(entities: Array<IBancoHorasColaboradores>): Array<IBancoHorasColaboradores> {
        entities.forEach((bancohorascolaborador: IBancoHorasColaboradores) => {
            bancohorascolaborador.bancohoras.forEach((banco: IBancoHoras) => {
                banco.apuracaoponto.periodo = moment(banco.apuracaoponto.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' - ' + moment(banco.apuracaoponto.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
            });
        });
        return entities;
    }

    filterReload(): void {
		this.busyFilter = true;
        this.filterTouched = false;
        this.entitiesLoaded = false;

        if (!this.filters.apuracaoinicial) {
            this.entities = [];
            this.busyFilter = false;
            this.entitiesLoaded = true;
            return;
        }

        const constructors = {
            apuracaoponto_inicioapuracao: {
                condition: 'gte',
                value: this.filters.apuracaoinicial.inicioapuracao
            },
            empresa: this.$rootScope.session.entities.empresa.empresa,
            estabelecimento: '',
        };

        if (this.filters.apuracaofinal) {
            constructors['apuracaoponto_terminoapuracao'] = {
                condition: 'lte',
                value: this.filters.apuracaofinal.terminoapuracao
            };
        }

        if (this.filters.trabalhador) {
            constructors['trabalhador_trabalhador'] = {
                condition: 'eq',
                value: this.filters.trabalhador?.trabalhador
            };
		}

        if (this.filters.departamento) {
            constructors['trabalhador_departamento'] = {
                condition: 'eq',
                value: this.filters.departamento?.departamento
            };
		}

        if (this.filters.grupo) {
            constructors['grupo'] = {
                condition: 'eq',
                value: this.filters.grupo?.grupo
            };
		}

        if (this.filters.lotacao) {
            constructors['lotacao_lotacao'] = {
                condition: 'eq',
                value: this.filters.lotacao?.lotacao
            };
		}

        if (this.filters.situacaoColaborador) {
            constructors['trabalhador_status'] = {
                condition: 'eq',
                value: this.filters.situacaoColaborador
            };
		}

		this.BancodeHorasService.constructors = constructors;
        this.entities = this.BancodeHorasService.reload();
    }

    apuracoesValidas(): boolean {
        if (!this.filters.apuracaoinicial) {
            return false;
        }
        // a data inicial tem que ser menor que a final
        if (
            this.filters.apuracaofinal &&
            (this.filters.apuracaoinicial.apuracaoponto !== this.filters.apuracaofinal.apuracaoponto)
        ) {
            const terminoDaApuracaoInicial = this.filters.apuracaoinicial.terminoapuracao;
            const inicioDaApuracaoFinal = this.filters.apuracaofinal.inicioapuracao;
            return moment(terminoDaApuracaoInicial, 'YYYY-MM-DD').isBefore(moment(inicioDaApuracaoFinal, 'YYYY-MM-DD'));
        }
        return true;
    }

    exportar(isPdf: boolean = false): void {
		this.busy = true;
        if (isPdf) {
            this.BancodeHorasService.exportarPDF(this.BancodeHorasService.constructors);
        } else {
            this.BancodeHorasService.exportar(this.BancodeHorasService.constructors);
        }
	}

    download(data: any, isPdf: boolean = false): void {
        let blob = new Blob([data]);
        let fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
        let a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        let apuracao = '';
		this.apuracoesSelect.forEach((element) => {
			if (element.apuracaoponto === this.filters.apuracaofinal?.apuracaoponto) {
				apuracao = element.terminoapuracao;
			}
			if (element.apuracaoponto === this.filters.apuracaoinicial?.apuracaoponto) {
				apuracao = element.inicioapuracao + '-a-' + apuracao;
			}
		});
        a.download = 'banco-de-horas-apuracao-' + apuracao + (isPdf ? '.pdf' : '.xlsx');
        a.click();
        window.URL.revokeObjectURL(fileURL);
	}

    agruparLotacoes(): any[] {
        const lotacoesMap = new Map<string, any>();

        for (const entity of this.entities) {
            for (const banco of entity.bancohoras) {
                const key = `${banco.trabalhador.codigo}-${banco.lotacao.nome}`;
                if (!lotacoesMap.has(key)) {
                    lotacoesMap.set(key, {
                        key: key.replace(/\s/g, ''),
                        nome: banco.trabalhador.nome,
                        codigo: banco.trabalhador.codigo,
                        bancohoras: [],
                        lotacao: {
                            nome: banco.lotacao.nome,
                        },
                    });
                }

                const lotacao = lotacoesMap.get(key);
                lotacao.bancohoras.push(banco);
            }
        }

        return Array.from(lotacoesMap.values());
    }
}

